import * as angular from "angular";
import {InstitutionModule} from "../institution/institution.module";
import {PriorStudyComponent} from "./prior-study.component";
import {PriorStudyUnitComponent} from "./unit/prior-study-unit.component";

export const PriorStudyModule = angular
    .module("app.shared.priorStudy", [
        InstitutionModule,
    ])

    .component("priorStudy", PriorStudyComponent)
    .component("priorStudyUnit", PriorStudyUnitComponent)

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/prior-study/prior-study.module.ts